import script from "./MTB_Slide_PatientData.vue?vue&type=script&setup=true&lang=js"
export * from "./MTB_Slide_PatientData.vue?vue&type=script&setup=true&lang=js"

import "./MTB_Slide_PatientData.vue?vue&type=style&index=0&id=2ac8a8fc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ac8a8fc"]])

export default __exports__